import React, { useEffect, useState } from 'react';
import ProductUpdates from './ProductUpdates';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
//import messageCenterSubject from "../../../../znotusedcurrently/rxjs/subjects/messagecenter/MessageCenterSubject.js2";

//let open = false;
const MessageCenter = observer(({}) => {
  const { messageCenterStore } = useWebsocketStore();
  const msgs = messageCenterStore.messageCenter;

  return <BuildCenter msgs={msgs} />;
});

export default MessageCenter;

/*export class MessageCenter1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {msgs: {}};
    }

    componentDidMount() {
        this.subscription = messageCenterSubject.subscribe((value) => {
            this.setState({msgs: value.messages});
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        return (
            <BuildCenter
                component={BuildCenter}
                observable={messageCenterSubject}
                msgs={this.state.msgs}
            />
        );
    }
}*/

function BuildCenter({ msgs }) {
  return <ProductUpdates msgs={msgs} />;
}
